import REQUEST, { _createUsersRequest } from '../../shared/http-request-util';

export const getUserData = async (userLoggedData) => {
  try {
    const result = await _createUsersRequest(userLoggedData).get('/garage');
    console.log('Result user garage', result.data);
    if (result && result.data) {
     return  result.data;
    }
    return null;
  } catch (error) {
    console.log('Error user garage:', error.response);
    REQUEST()._handleErrorRedirect(error)
    return null;
  }
};

export function isUserDataValid(userData) {
  let isValid = null;
  if (!userData) {
    isValid = false;
  } else if (!userData.name) {
    isValid = false;
  } else if (!userData.document) {
    isValid = false;
  } else {
    isValid = true
  }
  return isValid;
}


